var submitButton = 'Versandkosten';
var submitButtonDisabled = 'Berechnung...';

Shopify.Cart.ShippingCalculator.show({
  submitButton: submitButton,
  submitButtonDisabled: submitButtonDisabled,
  
  moneyFormat: "€\{\{\amount_with_comma_separator\}\}"
});

$('.expander').on('click', function(e) {
  e.preventDefault();
  var $parent = $(this).parent();
  $parent.toggleClass('opened');
  $parent.find('.expandable').slideToggle();
});
